/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class AppDefinitionsApi extends BaseApi {
    deleteAppDefinition(appDefinitionId) {
        throwIfNotDefined(appDefinitionId, 'appDefinitionId');
        const pathParams = {
            appDefinitionId
        };
        return this.delete({
            path: '/api/enterprise/app-definitions/{appDefinitionId}',
            pathParams
        });
    }
    exportAppDefinition(modelId) {
        throwIfNotDefined(modelId, 'modelId');
        const pathParams = {
            modelId
        };
        const contentTypes = ['application/json'];
        const accepts = ['application/json', 'application/zip'];
        return this.get({
            path: '/api/enterprise/app-definitions/{modelId}/export',
            pathParams,
            contentTypes,
            accepts
        });
    }
    getAppDefinition(modelId) {
        throwIfNotDefined(modelId, 'modelId');
        const pathParams = {
            modelId
        };
        return this.get({
            path: '/api/enterprise/app-definitions/{modelId}',
            pathParams
        });
    }
    importAndPublishApp(file, opts) {
        throwIfNotDefined(file, 'file');
        const formParams = {
            file
        };
        const queryParams = {
            renewIdmEntries: opts === null || opts === void 0 ? void 0 : opts.renewIdmEntries
        };
        return this.post({
            path: '/api/enterprise/app-definitions/publish-app',
            formParams,
            queryParams,
            contentTypes: ['multipart/form-data']
        });
    }
    importAppDefinition(file, opts) {
        throwIfNotDefined(file, 'file');
        const formParams = {
            file
        };
        return this.post({
            path: '/api/enterprise/app-definitions/import',
            queryParams: opts,
            formParams,
            contentTypes: ['multipart/form-data']
        });
    }
    publishAppDefinition(modelId, publishModel) {
        throwIfNotDefined(modelId, 'modelId');
        throwIfNotDefined(publishModel, 'publishModel');
        const pathParams = {
            modelId
        };
        return this.post({
            path: '/api/enterprise/app-definitions/{modelId}/publish',
            pathParams,
            bodyParam: publishModel
        });
    }
    updateAppDefinition(modelId, updatedModel) {
        throwIfNotDefined(modelId, 'modelId');
        throwIfNotDefined(updatedModel, 'updatedModel');
        const pathParams = {
            modelId
        };
        if (!updatedModel['appDefinition']) {
            const formParams = {
                file: updatedModel
            };
            return this.post({
                path: '/api/enterprise/app-definitions/{modelId}/import',
                pathParams,
                formParams,
                bodyParam: updatedModel,
                contentTypes: ['multipart/form-data']
            });
        }
        else {
            return this.put({
                path: '/api/enterprise/app-definitions/{modelId}',
                pathParams,
                bodyParam: updatedModel
            });
        }
    }
}
